import { XLoader } from '@adornis/chemistry/elements/components/x-loader.js';
import '@adornis/file-utils/client/x-image.js';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-loader
 */
@customElement('cr-loader')
export class ChromiumLoader extends XLoader {}
